import { ApiClient } from '../../../rest-api/fetsClient';
import { throwIfNotOk } from '../../../rest-api/throwIfNotOk';

type VersionParams = { courseExportGuid: string; versionGuid: string };
type SemanticVersion = { major: number; minor: number; patch: number };

type AddCourseExportVersionFromProjectParams = {
  courseExportGuid: string;
  projectId: number;
  mandatoryItemIds: number[];
  quizGuid: string | null;
  version: SemanticVersion;
  description: string;
  changelog: string | null;
  publishWhenProcessed: boolean;
};

export const createCourseExportVersionsApi = (apiClient: ApiClient) => {
  const deleteCourseExportVersion = async (params: VersionParams): Promise<void> => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}/versions/{versionGuid}'].delete({
      params,
    });
    await throwIfNotOk(response, 'delete the version');
  };

  const getCourseExportVersionPreviewUrl = async (params: VersionParams): Promise<string> => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}/versions/{versionGuid}/preview-url'].get({
      params,
    });
    await throwIfNotOk(response, 'open the preview');
    const data = await response.json();
    return data.url;
  };

  const addCourseExportVersionFromProject = async (
    params: AddCourseExportVersionFromProjectParams
  ): Promise<string> => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}/add-version-from-project'].post({
      params: { courseExportGuid: params.courseExportGuid },
      json: {
        projectId: params.projectId,
        mandatoryItemIds: params.mandatoryItemIds,
        quizGuid: params.quizGuid,
        description: params.description,
        version: params.version,
        changelog: params.changelog,
        publishWhenProcessed: params.publishWhenProcessed,
      },
    });
    await throwIfNotOk(response, 'create the version');
    return await response.json();
  };

  return { deleteCourseExportVersion, getCourseExportVersionPreviewUrl, addCourseExportVersionFromProject };
};
